export default __webpack_public_path__ + "static/portfolio-cover-7-94dff9e5a4ef68477ddd3a460dc65a4f.jpg";